import queryString from 'query-string';

export const isTruthyValue = (value?: string | (string | null)[] | null) => {
  const _value =
    typeof value === 'string' ? value.toLowerCase() : value?.[0]?.toLowerCase();

  return ['yes', 'true', 'y'].includes(_value ?? '');
};

export const getParsedQueryString = () => {
  return queryString.parse(window.location.search, {
    arrayFormat: 'comma',
  });
};

// Convert a key to kebab-case and lowercase without using regex
export const toKebabCase = (str: string): string => {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    const char = str[i];
    if (char === ' ') {
      // Replace spaces with hyphens
      result += '-';
    } else if (char >= 'A' && char <= 'Z') {
      if (i > 0) {
        result += '-';
      }
      result += char.toLowerCase();
    } else {
      // Otherwise, just add the character
      result += char;
    }
  }
  return result.toLowerCase();
};

export const updateQueryString = (queryObject: any) => {
  const parsedUrl = queryString.parseUrl(window.location.href);
  const url = parsedUrl.url;

  // Convert all keys to kebab-case and lowercase, and format values
  const formattedQueryObject: Record<string, any> = {};
  for (const [key, value] of Object.entries(queryObject)) {
    if (value !== undefined) {
      const formattedKey = toKebabCase(key);

      // Handle array values
      if (Array.isArray(value)) {
        // Format each item in the array
        formattedQueryObject[formattedKey] = value.map(item => {
          if (typeof item === 'string') {
            let result = '';
            for (let i = 0; i < item.length; i++) {
              const char = item[i];
              if (char === ' ') {
                result += '-';
              } else {
                result += char.toLowerCase();
              }
            }
            return result;
          }
          return item;
        });
      }
      // Handle string values
      else if (
        typeof value === 'string' &&
        formattedKey === 'measurement-checks-exclude'
      ) {
        const formattedValues = value
          .split(',')
          .map(item => {
            let result = '';
            for (let i = 0; i < item.length; i++) {
              const char = item[i];
              if (char === ' ') {
                result += '-';
              } else {
                result += char.toLowerCase();
              }
            }
            return result;
          })
          .join(',');

        formattedQueryObject[formattedKey] = formattedValues;
      }
      // For other string values or non-string values
      else {
        formattedQueryObject[formattedKey] = value;
      }
    }
  }

  // Create the query string
  const newQueryString = `?${queryString.stringify(formattedQueryObject, {
    arrayFormat: 'comma',
  })}`;

  // Avoid unnecessary updates if the query string hasn't changed
  if (window.location.search === newQueryString) {
    return;
  }

  // Update URL
  if (window.location.search === '') {
    window.history.replaceState({}, '', `${url}${newQueryString}`);
  } else {
    window.history.pushState({}, '', `${url}${newQueryString}`);
  }

  // Trigger a custom event so other components can react to URL changes
  const event = new CustomEvent('queryStringUpdated', {
    detail: { queryObject: formattedQueryObject },
  });
  window.dispatchEvent(event);
};
